export default () => {
    const productPayment = document.querySelector('*[product-payment]');
    if (productPayment == null)
        return;
    import(/* webpackChunkName: "ProductPayment" */ "../classes/productPaymentClass")
        .then(({ default: ProductPayment }) => {
        new ProductPayment();
    })
        .catch(() => "An error with Product Payment component occurred");
};
